import { useCallback, useState } from 'react';

export const useModal = (
    {
        modalName,
        onOpen,
        onClose,
    }: {
        modalName: string;
        onOpen?: () => void;
        onClose?: () => void;
    } = { modalName: '' }
) => {
    const [isOpen, setIsOpen] = useState(false);

    const open = useCallback(() => {
        setIsOpen(true);

        if (onOpen) onOpen();
    }, [modalName, onOpen, setIsOpen]);

    const close = useCallback(() => {
        setIsOpen(false);

        if (onClose) onClose();
    }, [modalName, onClose, setIsOpen]);

    return {
        isOpen,
        open,
        close,
    };
};
